import { isString } from 'lodash';
import PropTypes from 'prop-types';
// material
import { Box, Typography, Link } from '@material-ui/core';
//
import { MBreadcrumbs } from './@material-extend';

// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array,
  action: PropTypes.node,
  type: PropTypes.number,
  heading: PropTypes.string,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object
};

export default function HeaderBreadcrumbs({ links, action, type, heading, moreLink = '' || [], sx, ...other }) {
  return (
    <Box sx={{ mb: 0, ...sx }} >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom>
            {heading}
          </Typography>
          <MBreadcrumbs links={links} {...other} />
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      {
        (moreLink?.length > 0) && <Box sx={{ mt: 2 }}>
          {isString(moreLink) ? (
            <Link href={moreLink} target="_blank" variant="body2">
              {moreLink}
            </Link>
          ) : (
            moreLink.map((href) => (
              <Link noWrap key={href} href={href} variant="body2" target="_blank" sx={{ display: 'table' }} >
                {href}
              </Link>
            ))
          )}
        </Box>
      }

    </Box>
  );
}
